// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

const gp21Theme = {
  dark: false,
  colors: {
    primary: '#3E6054',
    'primary-darken-1': '#334F45',
    secondary: '#7DC4B2',
    'secondary-darken-1': '#42927E',
    accent: '#E79F27',

    background: '#FDFAF3',
    surface: '#FFFFFF',
    'surface-variant': '#F6E9CF',

    success: '#2F7D52',
    warning: '#C78516',
    error: '#B5412A',
    info: '#3E6F82',

    'on-primary': '#F6E9CF',
    'on-secondary': '#244F44',
    'on-accent': '#573A0A',
    'on-background': '#1F302A',
    'on-surface': '#1F302A',
    'on-surface-variant': '#1F302A',
  },
}

export default createVuetify({
  theme: {
    defaultTheme: 'gp21',
    themes: {
      gp21: gp21Theme,
    },
  },
})